import * as React from 'react';
import { Query } from 'react-apollo';
// @ts-ignore
import { AdminUpgradeSharedQuote, AdminUpgradeSharedQuoteVariables } from 'admin/queries/__generated__/AdminUpgradeSharedQuote';
import { AdminUpgradePlanSharedQuotePage } from 'admin/components/AdminUpgradePlan/AdminUpgradePlanSharedQuotePage';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import SHARED_QUOTE_QUERY from 'admin/queries/AdminUpgradeSharedQuoteQuery.gql';

import '../styles/AdminUpgradePlanSharedQuoteView.scss';

type Props = {
  shareToken: string;
};

export default function AdminUpgradePlanSharedQuoteView(props: Props) {
  return (
    <Query<AdminUpgradeSharedQuote, AdminUpgradeSharedQuoteVariables>
      query={SHARED_QUOTE_QUERY}
      variables={{ shareToken: props.shareToken }}
      fetchPolicy='network-only'>
      {({ loading, error, data }) => {
        const sharedQuote = data?.sharedQuote;

        if (sharedQuote) {
          return (
            <div className="AdminUpgradePlanSharedQuoteView">
              <AdminUpgradePlanSharedQuotePage
                quote={sharedQuote.quoteData || undefined}
                quoteState={sharedQuote.quoteState}
                loading={loading}
                error={error}
              />
            </div>
          );
        } else {
          return (
            <div className="AdminUpgradePlanSharedQuoteView">
              <CenteredLoadingIndicator data-test="loading" />
            </div>
          );
        }
      }}
    </Query>
  );
}
